export const APP_NAME = "CHATPATA";
export const TOKEN_KEY = "token";
